/**
 *  DoomBuggyView
 *
 *  Created by Legman on 27/03/2017.
 *
 */

import Common from "../Common";
import RaceCarView from "../race/RaceCarView"

/**
 * @class
 * @extends RaceCarView
 * @memberOf race
 */
export default class DoomBuggyView extends RaceCarView {
    constructor() {
        super();

        this._shadow.y = 122;

        this._front.offset.y = -152;
        this._back.offset.y = -152;

        this._wheels.front.left.offset = new PIXI.Point(-200, -20);
        this._wheels.front.right.offset = new PIXI.Point(200, -20);

        this._wheels.rear.left.offset = new PIXI.Point(-200, 20);
        this._wheels.rear.right.offset = new PIXI.Point(200, 20);

        /**
         * @type {Object}
         * @private
         */
        this._axles = {};

        /**
         * @type {Object}
         */
        this._axles.front = {};

        /**
         * @type {Object}
         */
        this._axles.rear = {};

        /**
         * @type {Sprite}
         */
        this._axles.front.left = this.createFrontAxle();
        this._axles.front.left.anchor = new PIXI.Point(0.5, 0.5);
        this.addChildAt(this._axles.front.left, 0);

        /**
         * @type {Sprite}
         */
        this._axles.front.right = this.createFrontAxle();
        this._axles.front.right.anchor = new PIXI.Point(0.5, 0.5);
        this._axles.front.right.scale.x = -1;
        this.addChildAt(this._axles.front.right, 0);


        /**
         * @type {Sprite}
         */
        this._axles.rear.left = this.createRearAxle();
        this._axles.rear.left.anchor = new PIXI.Point(0.5, 0.5);
        this.addChildAt(this._axles.rear.left, 6);

        /**
         * @type {Sprite}
         */
        this._axles.rear.right = this.createRearAxle();
        this._axles.rear.right.anchor = new PIXI.Point(0.5, 0.5);
        this._axles.rear.right.scale.x = -1;
        this.addChildAt(this._axles.rear.right, 6);
    }

    init() {
    }

    destroy(destroyChildren) {
    }

    /**
     * @param {number} dt
     * @param {number} distance
     * @param {number} curvature
     * @param {number} gradient
     * @param {number} velocity
     * @param {number} turnVelocity
     * @param {number} jumpOffset
     */
    update(dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset) {
        super.update(dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset);

        const scalar = 140;

        this._curvature += ((turnVelocity + curvature) - this._curvature) * 0.4;
        this._curvature = Math.max(-scalar, Math.min(scalar, this._curvature));

        this._front.x = this._curvature * 0.3 + this._front.offset.x;
        this._front.y = (-gradient * scalar * 1.6) + this._front.offset.y - (jumpOffset * 136);

        this._back.x = -this._curvature * 0.1 + this._back.offset.x;
        this._back.y = (gradient * scalar) + this._back.offset.y - (jumpOffset * 118);

        this._front.rotation = this._curvature * 0.0012;
        this._back.rotation = this._curvature * 0.0012;

        this._wheels.front.left.x = this._front.x + this._wheels.front.left.offset.x;
        this._wheels.front.left.y = (gradient * scalar) + this._wheels.front.left.offset.y - (jumpOffset * 74);

        this._wheels.front.right.x = this._front.x + this._wheels.front.right.offset.x;
        this._wheels.front.right.y = (gradient * scalar) + this._wheels.front.right.offset.y - (jumpOffset * 74);

        this._wheels.rear.left.x = this._back.x + this._wheels.rear.left.offset.x;
        this._wheels.rear.left.y = (gradient * scalar) + this._wheels.rear.left.offset.y - (jumpOffset * 72);

        this._wheels.rear.right.x = this._back.x + this._wheels.rear.right.offset.x;
        this._wheels.rear.right.y = (gradient * scalar) + this._wheels.rear.right.offset.y - (jumpOffset * 72);

        velocity = Math.max(0, velocity) / 0.2;
        this._wheels.front.left.animationSpeed = velocity;
        this._wheels.front.right.animationSpeed = velocity;
        this._wheels.rear.left.animationSpeed = velocity;
        this._wheels.rear.right.animationSpeed = velocity;

        this.updateAxles();
    }

    updateAxles() {
        // front axles
        let offset = new PIXI.Point(26, 84);
        let center = new PIXI.Point(this._front.x, this._front.y);
        let angle = this._front.rotation;
        let la = new PIXI.Point(
            center.x + (Math.cos(angle) * -offset.x - Math.sin(angle) * offset.y),
            center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * -offset.x)
        );
        let ra = new PIXI.Point(
            center.x + (Math.cos(angle) * offset.x - Math.sin(angle) * offset.y),
            center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * offset.x)
        );

        offset = new PIXI.Point(74, 0);
        center = new PIXI.Point(this._wheels.front.left.x, this._wheels.front.left.y);
        angle = this._wheels.front.left.rotation;
        let lb = new PIXI.Point(
            center.x + (Math.cos(angle) * offset.x - Math.sin(angle) * offset.y),
            center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * offset.x)
        );

        center = new PIXI.Point(this._wheels.front.right.x, this._wheels.front.right.y);
        angle = this._wheels.front.right.rotation;
        let rb = new PIXI.Point(
            center.x + (Math.cos(angle) * -offset.x - Math.sin(angle) * offset.y),
            center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * -offset.x)
        );

        let axle = new PIXI.Point(la.x + (lb.x - la.x) * 0.5, la.y + (lb.y - la.y) * 0.5);
        let axleAngle = Math.atan2(la.y - lb.y, la.x - lb.x);

        this._axles.front.left.x = axle.x;
        this._axles.front.left.y = axle.y;
        this._axles.front.left.rotation = axleAngle;

        axle = new PIXI.Point(ra.x + (rb.x - ra.x) * 0.5, ra.y + (rb.y - ra.y) * 0.5);
        axleAngle = Math.atan2(rb.y - ra.y, rb.x - ra.x);

        this._axles.front.right.x = axle.x;
        this._axles.front.right.y = axle.y;
        this._axles.front.right.rotation = axleAngle;

        // rear axles
        offset = new PIXI.Point(26, 112);
        center = new PIXI.Point(this._back.x, this._back.y);
        angle = this._back.rotation;
        la = new PIXI.Point(
            center.x + (Math.cos(angle) * -offset.x - Math.sin(angle) * offset.y),
            center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * -offset.x)
        );
        ra = new PIXI.Point(
            center.x + (Math.cos(angle) * offset.x - Math.sin(angle) * offset.y),
            center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * offset.x)
        );

        offset = new PIXI.Point(74, 0);
        center = new PIXI.Point(this._wheels.rear.left.x, this._wheels.rear.left.y);
        angle = this._wheels.rear.left.rotation;
        lb = new PIXI.Point(
            center.x + (Math.cos(angle) * offset.x - Math.sin(angle) * offset.y),
            center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * offset.x)
        );

        center = new PIXI.Point(this._wheels.rear.right.x, this._wheels.rear.right.y);
        angle = this._wheels.rear.right.rotation;
        rb = new PIXI.Point(
            center.x + (Math.cos(angle) * -offset.x - Math.sin(angle) * offset.y),
            center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * -offset.x)
        );

        axle = new PIXI.Point(la.x + (lb.x - la.x) * 0.5, la.y + (lb.y - la.y) * 0.5);
        axleAngle = Math.atan2(la.y - lb.y, la.x - lb.x);

        this._axles.rear.left.x = axle.x;
        this._axles.rear.left.y = axle.y;
        this._axles.rear.left.rotation = axleAngle;

        axle = new PIXI.Point(ra.x + (rb.x - ra.x) * 0.5, ra.y + (rb.y - ra.y) * 0.5);
        axleAngle = Math.atan2(rb.y - ra.y, rb.x - ra.x);

        this._axles.rear.right.x = axle.x;
        this._axles.rear.right.y = axle.y;
        this._axles.rear.right.rotation = axleAngle;
    }

    /**
     */
    startEngine() {
        this.stopEngine();

        TweenMax.to(this._front.offset, 0.05, {
            y: this._front.offset.y - 5.0,
            yoyo: true,
            repeat: -1
        });

        TweenMax.to(this._back.offset, 0.05, {
            y: this._back.offset.y - 7.0,
            yoyo: true,
            repeat: -1
        });

        TweenMax.to(this._front.scale, 0.04, {
            y: this._front.scale.y - 0.04,
            yoyo: true,
            repeat: -1
        });

        TweenMax.to(this._back.scale, 0.04, {
            delay: 0.02,
            y: this._back.scale.y - 0.02,
            yoyo: true,
            repeat: -1
        });

        TweenMax.to(this._wheels.front.left.offset, 0.04, {
            y: this._wheels.front.left.offset.y - 4.0,
            yoyo: true,
            repeat: -1
        });

        TweenMax.to(this._wheels.front.right.offset, 0.04, {
            y: this._wheels.front.right.offset.y - 4.0,
            yoyo: true,
            repeat: -1
        });

        TweenMax.to(this._wheels.rear.left.offset, 0.03, {
            y: this._wheels.rear.left.offset.y - 6.0,
            yoyo: true,
            repeat: -1
        });

        TweenMax.to(this._wheels.rear.right.offset, 0.03, {
            y: this._wheels.rear.right.offset.y - 6.0,
            yoyo: true,
            repeat: -1
        });
    }

    /**
     */
    stopEngine() {
        TweenMax.killTweensOf(this._front.offset);
        TweenMax.killTweensOf(this._back.offset);
        TweenMax.killTweensOf(this._front.scale);
        TweenMax.killTweensOf(this._back.scale);
        TweenMax.killTweensOf(this._wheels.front.left.offset);
        TweenMax.killTweensOf(this._wheels.front.right.offset);
        TweenMax.killTweensOf(this._wheels.rear.left.offset);
        TweenMax.killTweensOf(this._wheels.rear.right.offset);
    }

    /**
     * @returns {PIXI.Sprite}
     */
    createFrontLayer() {
        const assets = Common.assets;
        return new PIXI.Sprite(assets.getTexture("grusome_front_00"));
    }

    /**
     * @returns {PIXI.Sprite}
     */
    createBackLayer() {
        const assets = Common.assets;
        return new PIXI.Sprite(assets.getTexture("grusome_rear_00"));
    }

    /**
     * @returns {p3.MovieClip}
     */
    createFrontWheel() {
        const assets = Common.assets;
        const sequence = new p3.MovieClipSequence();
        sequence.addTextures([
            assets.getTexture("grusome_front_wheel_spin_00"),
            assets.getTexture("grusome_front_wheel_spin_01")
        ]);
        return new p3.MovieClip(sequence);
    }

    /**
     * @returns {p3.MovieClip}
     */
    createRearWheel() {
        const assets = Common.assets;
        const sequence = new p3.MovieClipSequence();
        sequence.addTextures([
            assets.getTexture("grusome_rear_wheel_spin_00"),
            assets.getTexture("grusome_rear_wheel_spin_01")
        ]);
        return new p3.MovieClip(sequence);
    }

    /**
     * @returns {PIXI.Sprite}
     */
    createShadow() {
        const assets = Common.assets;
        return new PIXI.Sprite(assets.getTexture("grusome_shadow_00"));
    }

    /**
     * @returns {PIXI.Sprite}
     */
    createFrontAxle() {
        const assets = Common.assets;
        return new PIXI.Sprite(assets.getTexture("grusome_front_axle_bottom_00"));
    }

    /**
     * @returns {PIXI.Sprite}
     */
    createRearAxle() {
        const assets = Common.assets;
        return new PIXI.Sprite(assets.getTexture("grusome_rear_axle_bottom_00"));
    }
}